export enum CookieKey {
  HomeSectionViewMode = 'homeSectionViewMode',
  FavoriteCategoryIds = 'favoriteCategoryIds',
}

export const CookieExpireTime: Record<CookieKey, number> = {
  [CookieKey.HomeSectionViewMode]: 365 * 24 * 60 * 60 * 1000, // 1 year
  [CookieKey.FavoriteCategoryIds]: 365 * 24 * 60 * 60 * 1000, // 1 year
};
